import { Text } from '@cloudflare/kumo'
import type { ReactNode } from 'react'

/** 페이지 제목 + 한 줄 설명 + 오른쪽 액션. 좁아지면 액션이 아래로 내려간다 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string
  description: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex min-w-0 flex-col gap-1">
        <Text variant="heading" size="lg">
          {title}
        </Text>
        <Text variant="secondary">{description}</Text>
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
